// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c1d79d26","453":"0f4552a2"}[chunkId] + ".chunk.js";
};